import React from 'react'
import { FieldsGrid } from '../../PaymentDetailModal/PaymentDetailModal.styles'
import { EscalationReasonFields } from './EscalationReasonFields'
import { TicketField } from './TicketField'

export function UnpaidEscalationFields() {
  return (
    <div style={{ marginTop: '16px' }}>
      <FieldsGrid>
        <TicketField />
        <EscalationReasonFields />
      </FieldsGrid>
    </div>
  )
}
